"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Nav = _interopRequireDefault(require("./Nav"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _has2 = _interopRequireDefault(require("lodash/has"));
var _findNav = _interopRequireDefault(require("../../helpers/findNav.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var NavComponent = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(NavComponent, _React$Component);
  function NavComponent() {
    _classCallCheck(this, NavComponent);
    return _callSuper(this, NavComponent, arguments);
  }
  _createClass(NavComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        routes = _this$props.routes,
        className = _this$props.className,
        isInverse = _this$props.isInverse,
        navHandle = _this$props.navHandle;
      var nav = navHandle ? this.props.navs.find(function (n) {
        return n.handle === navHandle;
      }) : (0, _findNav["default"])(this.props.navs, this.props.routes);
      if (!nav || (0, _isEmpty2["default"])(nav.nav)) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_Nav["default"], {
        nav: nav,
        routes: routes,
        className: className,
        id: this.props.id,
        isInverse: (0, _has2["default"])(nav, 'isInverse') ? nav.isInverse : isInverse,
        render: this.props.render
      });
    }
  }]);
  return NavComponent;
}(_react["default"].Component);
_defineProperty(NavComponent, "propTypes", {
  /**
   * The nav json array
   */
  navs: _propTypes["default"].array,
  /**
   * The handle of the specific nav to use.
   */
  navHandle: _propTypes["default"].string,
  /**
   * The routes json array
   */
  routes: _propTypes["default"].array,
  /**
   * Bootstrap container or container-fluid
   */
  className: _propTypes["default"].string,
  /**
   * Adds unique classname to navbar, if you have many on site
   */
  id: _propTypes["default"].string,
  /** Show inverse bootstrap style or not? */
  isInverse: _propTypes["default"].bool,
  /** Custom render function for custom navigations  */
  render: _propTypes["default"].func
});
_defineProperty(NavComponent, "defaultProps", {
  className: 'container',
  id: '',
  isInverse: false
});